import { useEffect, useRef, useState } from 'react';
import { CHANGE_EVENT, MODES, POLL_MS, STORAGE_KEYS } from './config';
import { readAttempts, readLog, readMode } from './storage';
import { withLock } from './lock';
import { runTick } from './runner';

const isOwnKey = (key) => !key || Object.values(STORAGE_KEYS).includes(key);

// Fon jarayoni: rejim "off" bo'lmasa har daqiqada tekshiradi. Rejim boshqa tabda
// o'zgarsa (storage hodisasi) yoki shu tabda o'zgarsa (CHANGE_EVENT) darhol qo'llanadi.
export function useAutoContinueRunner(notify) {
  const notifyRef = useRef(notify);
  notifyRef.current = notify;

  useEffect(() => {
    let timer = null;
    let currentMode = null;

    const tick = () =>
      withLock(() => runTick({ notify: (...args) => notifyRef.current?.(...args) })).catch((error) => {
        console.log('Avto-davom tekshiruvi xatosi:', error);
      });

    const apply = () => {
      const mode = readMode();
      if (mode === currentMode) return;
      currentMode = mode;
      if (timer) clearInterval(timer);
      timer = null;
      if (mode === MODES.OFF) return;
      tick();
      timer = setInterval(tick, POLL_MS);
    };

    const onStorage = (event) => {
      if (!event.key || event.key === STORAGE_KEYS.mode) apply();
    };
    const onChange = (event) => {
      if (event.detail?.key === STORAGE_KEYS.mode) apply();
    };

    apply();
    window.addEventListener('storage', onStorage);
    window.addEventListener(CHANGE_EVENT, onChange);
    return () => {
      if (timer) clearInterval(timer);
      window.removeEventListener('storage', onStorage);
      window.removeEventListener(CHANGE_EVENT, onChange);
    };
  }, []);
}

// Panel va badge'lar uchun: rejim, urinishlar va jurnal (localStorage'dan, jonli yangilanadi)
export function useAutoContinueState() {
  const read = () => ({ mode: readMode(), attempts: readAttempts(), log: readLog(), now: Date.now() });
  const [state, setState] = useState(read);

  useEffect(() => {
    const refresh = () => setState(read());
    const onStorage = (event) => {
      if (isOwnKey(event.key)) refresh();
    };
    window.addEventListener('storage', onStorage);
    window.addEventListener(CHANGE_EVENT, refresh);
    const timer = setInterval(refresh, 30 * 1000); // "keyingisi N daq." matni uchun
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener(CHANGE_EVENT, refresh);
      clearInterval(timer);
    };
  }, []);

  return state;
}
